export default "__VITE_ASSET__DCaxewGa__"